var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Space--inject-1--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173,82.4a381.79,381.79,0,0,0-114.91,100C42.24,203.16,33.76,130.84,50,102.7s65-51.6,113.73-51.6S205.67,64,173,82.4Z",
    style: {
      fill: "#042C71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.09,400.84c-78.11-40.9-54.87-142.6,7.72-216.21,104.1-122.44,245-174.39,333.66-105.38s90.46,237,59.62,286-99.72,71.22-219.51,71.22S103.72,420.54,66.09,400.84Z",
    style: {
      fill: "#042C71"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Smoke--inject-1--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.15,344.56a98.13,98.13,0,0,1-6.83,16.78q-1.08,2.06-2.24,3.88c-1,1.6-2.05,3.17-3.15,4.71-1.3,1.85-2.67,3.67-4.11,5.44q-3.15,3.93-6.72,7.6a113.55,113.55,0,0,1-10.54,9.55c-16,12.81-36.54,22.67-62.24,29.77,0,0-41,12.83-129.45,12.83S113,422.29,113,422.29c-1-.3-1.88-.61-2.8-.93C96,416.51,84.89,410.75,73,404.5l-7-3.66C51.17,393,40,383,32,371.38a83.7,83.7,0,0,1-5.8-9.86C14.64,338.33,14,310.19,21.47,281.08q.75-3,1.64-6a209.29,209.29,0,0,1,10.28-27.49c.12-.28.25-.55.38-.83h0l.45.31c.36.25.7.5,1,.76s.67.51,1,.77a37.9,37.9,0,0,1,4.56,4.3c.53.59,1,1.2,1.55,1.82.28.35.56.71.83,1.08l.65.9q.4.57.78,1.17l.66,1.06c.18.3.36.61.53.92.06.1.12.2.17.3.18.32.35.65.52,1s.38.75.56,1.13.31.66.45,1c.37.83.7,1.68,1,2.54.15.39.28.79.41,1.2l0,.08c.12.37.23.76.34,1.14l.24.9.15.6c.16.67.3,1.36.43,2,0,.26.09.52.13.79s.09.56.13.85.09.78.13,1.17.08.84.12,1.27c.06.9.09,1.8.09,2.72a38.09,38.09,0,0,1-3.48,15.93,38.76,38.76,0,0,1-6.89,10.25,26.85,26.85,0,0,1,13.14,9.32,38.4,38.4,0,0,1,44.66.57c.49.36,1,.73,1.43,1.11a38,38,0,0,1,5.15,5.08c.39.46.76.94,1.13,1.42q.81,1.08,1.56,2.22a36.22,36.22,0,0,1,1.83,3.14c.28.54.54,1.08.8,1.64.5,1.1,1,2.24,1.36,3.4a37.09,37.09,0,0,1,2,12,37.74,37.74,0,0,1-.27,4.53,36.82,36.82,0,0,1-2.11,8.54c-.11.27-.21.54-.32.8h0A17,17,0,0,1,121.88,363a27.07,27.07,0,0,1,12.46-7.33h0l.86-.22a18.48,18.48,0,0,1,2.59-.48c.31-.06.62-.09.93-.12s.87-.08,1.31-.1.95,0,1.43,0a27,27,0,0,1,19.23,8A26.35,26.35,0,0,1,167.59,375a38.92,38.92,0,0,1,20.08-5.52c21.42,0,38.8,17.13,38.8,38.27,0,.18,0,.38,0,.58a17.05,17.05,0,0,1,25,7.54,17,17,0,0,1,27-6.05,33,33,0,0,1-.23-3.75,32.35,32.35,0,0,1,9.16-22.57L288,383c.56-.56,1.15-1.09,1.75-1.61.4-.34.81-.67,1.22-1l.64-.48c.42-.31.86-.62,1.3-.91a31.31,31.31,0,0,1,2.73-1.64l.71-.37c.48-.24,1-.47,1.45-.69s1-.43,1.49-.62,1-.38,1.52-.55a33.6,33.6,0,0,1,32.28,6.2c.76.64,1.48,1.31,2.18,2A33.23,33.23,0,0,1,339,387.9a17,17,0,0,1,7.17-3.34h0a34.82,34.82,0,0,1-.95-3.68c-.08-.42-.16-.84-.23-1.27a32.85,32.85,0,0,1-.41-5.19,32.48,32.48,0,0,1,.27-4.21q.11-.88.27-1.77a31.53,31.53,0,0,1,1.27-4.86q.3-.9.66-1.77c.18-.43.37-.86.56-1.29a33.84,33.84,0,0,1,7-10,34.39,34.39,0,0,1,24.21-9.89,36.09,36.09,0,0,1,5.44.42c.87.14,1.74.31,2.59.51h0l1.28.33,1,.3q.76.24,1.5.51l1.22.47c.4.16.8.34,1.2.52l.87.41.23.11A34,34,0,0,1,411,363a16.93,16.93,0,0,1,11.42-4.4c.51,0,1,0,1.51.06a11.24,11.24,0,0,1-.08-1.31,14,14,0,0,1,5.18-10.85l-1.26-.34a31.23,31.23,0,0,1-9.16-4.43c-.69-.49-1.36-1-2-1.53s-1.28-1.1-1.87-1.69a30.38,30.38,0,0,1-9.22-21.81,28.44,28.44,0,0,1,.27-3.94c.08-.59.18-1.18.29-1.77s.29-1.35.47-2c-.8-.15-1.6-.34-2.38-.56l-1.15-.35c-.77-.26-1.52-.54-2.25-.85s-1.45-.66-2.15-1a28.09,28.09,0,0,1-4.89-3.29,27.27,27.27,0,0,1-9.8-20.93c0-.46,0-.91,0-1.37v-.11c0-.35,0-.7.08-1,0-.15,0-.3,0-.44a.13.13,0,0,1,0-.06c0-.37.08-.72.14-1.08,0-.09,0-.18,0-.27.06-.4.14-.79.22-1.17s.18-.82.28-1.23.17-.63.27-.94.15-.52.23-.77c.21-.64.45-1.28.71-1.9.1-.25.21-.5.32-.75l.12-.25c.11-.24.22-.48.34-.71.31-.64.66-1.27,1-1.89l.31-.5a1.82,1.82,0,0,1,.15-.23c.27-.43.55-.84.86-1.25a1.37,1.37,0,0,1,.15-.21l.4-.53a19.31,19.31,0,0,1,1.31-1.56c.21-.23.42-.46.64-.68s.43-.45.66-.66.45-.44.68-.64.45-.41.68-.61l0,0a24.3,24.3,0,0,1,2.23-1.7,27.92,27.92,0,0,1,15.93-4.94,29.09,29.09,0,0,1,5.24.49c0-.17,0-.32,0-.49a14.14,14.14,0,0,1,.11-1.85c0-.24.05-.47.09-.7a3.06,3.06,0,0,1,.05-.32c.07-.43.16-.85.27-1.27a.07.07,0,0,0,0,0,15.4,15.4,0,0,1,.48-1.5c.09-.25.19-.5.29-.75s.17-.39.26-.58.14-.3.22-.45a16.44,16.44,0,0,1,2.52-3.66l.35-.37a11.63,11.63,0,0,1,.87-.85,5.82,5.82,0,0,1,.48-.41l.46-.37a12.65,12.65,0,0,1,1.5-1.05l.53-.32.54-.29c.19-.11.39-.21.58-.3.37-.17.73-.33,1.11-.47l.58-.22c.35-.12.7-.24,1.07-.33s.54-.15.82-.21l.55-.11a10.33,10.33,0,0,1,1.26-.19l.65-.06.65,0c.22,0,.44,0,.67,0a16.89,16.89,0,0,1,10.95,4,12.36,12.36,0,0,1,12.41-11.75l.4,0a27.15,27.15,0,0,1-3.53-13.39,27.56,27.56,0,0,1,20-26.37,335.31,335.31,0,0,1,10.82,77.14C485.8,297.21,482.45,324.47,476.15,344.56Z",
    style: {
      fill: "#084387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.06,416.93H300.15a18,18,0,0,1,35.91,0Z",
    style: {
      fill: "#042C71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.2,421.36C96,416.51,84.89,410.75,73,404.5a23,23,0,0,1,37.16,16.86Z",
    style: {
      fill: "#042C71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.36,421H144.53a15.46,15.46,0,0,1-3.1-9.29,15.8,15.8,0,0,1,31.59-.37A23.09,23.09,0,0,1,211.36,421Z",
    style: {
      fill: "#042C71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.32,361.34q-1.08,2.06-2.24,3.88c-1,1.6-2.05,3.17-3.15,4.71-1.3,1.85-2.67,3.67-4.11,5.44q-3.15,3.93-6.72,7.6a113.55,113.55,0,0,1-10.54,9.55c-16,12.81-36.54,22.67-62.24,29.77l-20.84,3.65-.1-3.65a38,38,0,0,1,51.11-14.91A17.48,17.48,0,0,1,427,395.75a17.82,17.82,0,0,1,4.82.68A37.42,37.42,0,0,1,469.32,361.34Z",
    style: {
      fill: "#042C71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.15,344.56a24.86,24.86,0,0,1-4.27-46.11A17.54,17.54,0,0,1,465.54,285a17.82,17.82,0,0,1,17.95-17.71c.54,0,1.07,0,1.59.07C485.8,297.21,482.45,324.47,476.15,344.56Z",
    style: {
      fill: "#042C71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.21,371.73a24.94,24.94,0,0,0-13.72-22.19,17.54,17.54,0,0,0,6.34-13.49,17.82,17.82,0,0,0-17.95-17.71c-.45,0-.89,0-1.32.06.09,15.47,3.14,30.08,9.64,43.12a83.7,83.7,0,0,0,5.8,9.86,84.92,84.92,0,0,0,8.85,10.84A24.58,24.58,0,0,0,43.21,371.73Z",
    style: {
      fill: "#042C71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.1,286.92a5.5,5.5,0,1,1,5.5,5.43A5.46,5.46,0,0,1,442.1,286.92Z",
    style: {
      fill: "#042C71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.48,344.31a5.5,5.5,0,1,1,5.5,5.43A5.46,5.46,0,0,1,58.48,344.31Z",
    style: {
      fill: "#042C71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.79,400.94a5.78,5.78,0,1,1,5.78,5.7A5.73,5.73,0,0,1,126.79,400.94Z",
    style: {
      fill: "#042C71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.32,409.85a5.78,5.78,0,1,1,5.78,5.7A5.74,5.74,0,0,1,346.32,409.85Z",
    style: {
      fill: "#042C71"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 430.82,
    cy: 219.62,
    rx: 4.32,
    ry: 4.26,
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.77,345.58a4,4,0,1,1,4,3.9A3.92,3.92,0,0,1,328.77,345.58Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.91,
    cy: 333.26,
    rx: 3.21,
    ry: 3.17,
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.13,285.71a6.13,6.13,0,1,1,6.13,6A6.09,6.09,0,0,1,60.13,285.71Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.26,410.56c-.25-.25-.52-.48-.78-.71a32.66,32.66,0,0,0,.63,3.58C279.11,412.46,279.17,411.51,279.26,410.56Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,387.91a33.27,33.27,0,0,0-60.76,18.19,31.07,31.07,0,0,0,.24,3.75c.26.23.53.46.78.71a33.26,33.26,0,0,1,56.9-19.77,32.5,32.5,0,0,1,8.44,15.35v0A32.26,32.26,0,0,0,339,387.91Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.67,344a35.53,35.53,0,0,1,4.53.3,34.53,34.53,0,0,0-15.37-3.6,34,34,0,0,0-34.23,33.76,33.37,33.37,0,0,0,1.57,10.15,34.17,34.17,0,0,0,28.12,23.31,34.31,34.31,0,0,1-7.79-5.32,33.59,33.59,0,0,1-10.11-16.94,33.24,33.24,0,0,1-.95-7.9A34,34,0,0,1,389.67,344Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,341.36a31,31,0,0,1-31.21-30.78c0-.42,0-.83.06-1.25a30.64,30.64,0,0,1,1.09-6.95,27.83,27.83,0,0,1-22.53-27,27.18,27.18,0,0,1,6.79-18,27.38,27.38,0,0,0,7.4,51.5,30.35,30.35,0,0,0-1,7.73,30.84,30.84,0,0,0,23.51,29.8,14.42,14.42,0,0,1,17.44-.57,31.14,31.14,0,0,0,12.8-8A31.43,31.43,0,0,1,445,341.36Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.38,270.79c.42-.08.84-.19,1.25-.3-.5,0-1-.09-1.48-.17C437.23,270.48,437.31,270.63,437.38,270.79Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.15,270.32a16.82,16.82,0,0,1-14.06-13.6,16.29,16.29,0,0,1-.28-2.9,16.56,16.56,0,0,1,1-5.7,16.87,16.87,0,0,1,11.35-10.39c-.38,0-.76-.06-1.15-.06A17,17,0,0,0,418.39,248a16.37,16.37,0,0,0-1.31,6.42c0,.17,0,.34,0,.51A16.84,16.84,0,0,0,434,271.12a16.67,16.67,0,0,0,3.34-.33C437.31,270.63,437.23,270.48,437.15,270.32Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.13,380.82a38.66,38.66,0,0,1,7.46-5.8,26.86,26.86,0,0,0-26.17-20.35,27.37,27.37,0,0,0-7.12,1A26.72,26.72,0,0,1,160.13,380.82Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.42,307.21l-.82,0A37.61,37.61,0,0,1,105,344a36.86,36.86,0,0,1-4.58,17.84,37.69,37.69,0,0,1-6,8.14A38.1,38.1,0,0,1,67.81,381.4a38.89,38.89,0,0,0,7.61.75,38.26,38.26,0,0,0,18.22-4.58,37.78,37.78,0,0,0,17.07-19,36.83,36.83,0,0,0,2.7-13.88C113.41,324,96.4,307.21,75.42,307.21Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.72,278.57a38.17,38.17,0,0,1-10.38,26.18,26.85,26.85,0,0,0-14.89-.52,38.42,38.42,0,0,0,17-31.87,38.11,38.11,0,0,0-9.1-24.74c.12-.28.25-.55.38-.83A38.36,38.36,0,0,1,50.72,278.57Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.26,410.56c-.25-.25-.52-.48-.78-.71a32.66,32.66,0,0,0,.63,3.58C279.11,412.46,279.17,411.51,279.26,410.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M339,387.91a33.27,33.27,0,0,0-60.76,18.19,31.07,31.07,0,0,0,.24,3.75c.26.23.53.46.78.71a33.26,33.26,0,0,1,56.9-19.77,32.5,32.5,0,0,1,8.44,15.35v0A32.26,32.26,0,0,0,339,387.91Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M389.67,344a35.53,35.53,0,0,1,4.53.3,34.53,34.53,0,0,0-15.37-3.6,34,34,0,0,0-34.23,33.76,33.37,33.37,0,0,0,1.57,10.15,34.17,34.17,0,0,0,28.12,23.31,34.31,34.31,0,0,1-7.79-5.32,33.59,33.59,0,0,1-10.11-16.94,33.24,33.24,0,0,1-.95-7.9A34,34,0,0,1,389.67,344Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M445,341.36a31,31,0,0,1-31.21-30.78c0-.42,0-.83.06-1.25a30.64,30.64,0,0,1,1.09-6.95,27.83,27.83,0,0,1-22.53-27,27.18,27.18,0,0,1,6.79-18,27.38,27.38,0,0,0,7.4,51.5,30.35,30.35,0,0,0-1,7.73,30.84,30.84,0,0,0,23.51,29.8,14.42,14.42,0,0,1,17.44-.57,31.14,31.14,0,0,0,12.8-8A31.43,31.43,0,0,1,445,341.36Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M437.38,270.79c.42-.08.84-.19,1.25-.3-.5,0-1-.09-1.48-.17C437.23,270.48,437.31,270.63,437.38,270.79Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M437.15,270.32a16.82,16.82,0,0,1-14.06-13.6,16.29,16.29,0,0,1-.28-2.9,16.56,16.56,0,0,1,1-5.7,16.87,16.87,0,0,1,11.35-10.39c-.38,0-.76-.06-1.15-.06A17,17,0,0,0,418.39,248a16.37,16.37,0,0,0-1.31,6.42c0,.17,0,.34,0,.51A16.84,16.84,0,0,0,434,271.12a16.67,16.67,0,0,0,3.34-.33C437.31,270.63,437.23,270.48,437.15,270.32Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.13,380.82a38.66,38.66,0,0,1,7.46-5.8,26.86,26.86,0,0,0-26.17-20.35,27.37,27.37,0,0,0-7.12,1A26.72,26.72,0,0,1,160.13,380.82Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.42,307.21l-.82,0A37.61,37.61,0,0,1,105,344a36.86,36.86,0,0,1-4.58,17.84,37.69,37.69,0,0,1-6,8.14A38.1,38.1,0,0,1,67.81,381.4a38.89,38.89,0,0,0,7.61.75,38.26,38.26,0,0,0,18.22-4.58,37.78,37.78,0,0,0,17.07-19,36.83,36.83,0,0,0,2.7-13.88C113.41,324,96.4,307.21,75.42,307.21Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.72,278.57a38.17,38.17,0,0,1-10.38,26.18,26.85,26.85,0,0,0-14.89-.52,38.42,38.42,0,0,0,17-31.87,38.11,38.11,0,0,0-9.1-24.74c.12-.28.25-.55.38-.83A38.36,38.36,0,0,1,50.72,278.57Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-1--inject-10"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.03,
    cy: 424.93,
    rx: 62.59,
    ry: 25.66,
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.03,
    cy: 424.93,
    rx: 62.59,
    ry: 25.66,
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.03,
    cy: 424.93,
    rx: 62.59,
    ry: 25.66,
    style: {
      fill: "#f4f4f4",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.29,411.67a27.81,27.81,0,0,1,55.6,0c0,.27,0,.51,0,.78s0,.51,0,.77c-.32,3.85-3,7.63-8.14,10.59-10.85,6.27-28.48,6.27-39.35,0-5.08-3-7.8-6.74-8.11-10.59,0-.26,0-.5,0-.77S186.27,411.94,186.29,411.67Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.29,411.67a27.81,27.81,0,0,1,55.6,0c0,.27,0,.51,0,.78s0,.51,0,.77c-.32,3.85-3,7.63-8.14,10.59-10.85,6.27-28.48,6.27-39.35,0-5.08-3-7.8-6.74-8.11-10.59,0-.26,0-.5,0-.77S186.27,411.94,186.29,411.67Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,387.4h0a27.79,27.79,0,0,1,39.87,24.27c0,.27,0,.51,0,.78s0,.51,0,.77c-.32,3.85-3,7.63-8.14,10.59a37.08,37.08,0,0,1-13.95,4.35c7.21-1.25,11.88-9.3,9.66-18.19C226.89,399.65,216.46,384.74,202,387.4Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.29,413.22c0-.26,0-.5,0-.77s0-.51,0-.78a27.68,27.68,0,0,1,9.44-20.09c-3,3.11-9.74,14.81-2.44,23.74,4.8,5.87,27.6,14.24,46.36,3.48a19.56,19.56,0,0,1-5.9,5c-10.85,6.27-28.48,6.27-39.35,0C189.32,420.85,186.6,417.07,186.29,413.22Z",
    style: {
      fill: "#F36B1C",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.37,390.9c-1.24,2.83,1.15,6.62,5.34,8.46s8.61,1,9.85-1.79-1.15-6.63-5.34-8.47S215.62,388.06,214.37,390.9Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.48,402.43c-.65,1.48.29,3.32,2.1,4.12s3.8.24,4.45-1.24-.29-3.32-2.1-4.11S231.13,401,230.48,402.43Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.74,417.68a23.61,23.61,0,0,0-47.21,0c0,.23,0,.44,0,.66s0,.43,0,.66c.26,3.27,2.57,6.48,6.91,9,9.21,5.32,24.18,5.32,33.41,0,4.32-2.51,6.62-5.72,6.89-9,0-.23,0-.43,0-.66S300.76,417.91,300.74,417.68Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.74,417.68a23.61,23.61,0,0,0-47.21,0c0,.23,0,.44,0,.66s0,.43,0,.66c.26,3.27,2.57,6.48,6.91,9,9.21,5.32,24.18,5.32,33.41,0,4.32-2.51,6.62-5.72,6.89-9,0-.23,0-.43,0-.66S300.76,417.91,300.74,417.68Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.38,397.07h0a23.58,23.58,0,0,0-33.85,20.61c0,.23,0,.44,0,.66s0,.43,0,.66c.26,3.27,2.57,6.48,6.91,9a31.4,31.4,0,0,0,11.84,3.69c-6.12-1.05-10.09-7.89-8.2-15.45C266.26,407.47,275.12,394.81,287.38,397.07Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.74,419c0-.23,0-.43,0-.66s0-.43,0-.66a23.47,23.47,0,0,0-8-17.06c2.56,2.64,8.27,12.58,2.07,20.16-4.08,5-23.44,12.1-39.38,3a16.63,16.63,0,0,0,5,4.25c9.21,5.32,24.18,5.32,33.41,0C298.17,425.48,300.47,422.27,300.74,419Z",
    style: {
      fill: "#F36B1C",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.89,400c1.06,2.41-1,5.63-4.53,7.19s-7.31.88-8.37-1.53,1-5.62,4.54-7.19S275.84,397.63,276.89,400Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.21,409.84a3.1,3.1,0,1,1-3.78-1A2.81,2.81,0,0,1,263.21,409.84Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.74,421.73a15.62,15.62,0,0,0-31.22,0,4.85,4.85,0,0,0,0,.88c.17,2.16,1.7,4.28,4.57,5.94,6.09,3.52,16,3.52,22.09,0,2.86-1.66,4.38-3.78,4.56-5.94,0-.15,0-.29,0-.44S324.75,421.88,324.74,421.73Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.74,421.73a15.62,15.62,0,0,0-31.22,0,4.85,4.85,0,0,0,0,.88c.17,2.16,1.7,4.28,4.57,5.94,6.09,3.52,16,3.52,22.09,0,2.86-1.66,4.38-3.78,4.56-5.94,0-.15,0-.29,0-.44S324.75,421.88,324.74,421.73Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.91,408.11h0a15.6,15.6,0,0,0-22.39,13.62,4.85,4.85,0,0,0,0,.88c.17,2.16,1.7,4.28,4.57,5.94a20.56,20.56,0,0,0,7.83,2.44c-4.05-.7-6.67-5.22-5.42-10.21C301.94,415,307.8,406.61,315.91,408.11Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.74,422.61c0-.15,0-.29,0-.44s0-.29,0-.44a15.53,15.53,0,0,0-5.3-11.28c1.7,1.74,5.47,8.32,1.37,13.33-2.7,3.3-15.5,8-26,2a11.13,11.13,0,0,0,3.32,2.81c6.09,3.52,16,3.52,22.09,0C323,426.89,324.56,424.77,324.74,422.61Z",
    style: {
      fill: "#F36B1C",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,410.07c.7,1.59-.64,3.72-3,4.75s-4.83.58-5.53-1,.64-3.72,3-4.75S308.27,408.47,309,410.07Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.92,416.55a2.05,2.05,0,0,1-3.68,1.61,2,2,0,0,1,3.68-1.61Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.58,424.41a21.22,21.22,0,0,0-42.43,0,5.82,5.82,0,0,0,0,.59,5.72,5.72,0,0,0,0,.59c.24,2.94,2.31,5.82,6.21,8.08,8.28,4.79,21.73,4.79,30,0,3.88-2.26,5.95-5.14,6.19-8.08a5.72,5.72,0,0,0,0-.59A5.82,5.82,0,0,0,360.58,424.41Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.58,424.41a21.22,21.22,0,0,0-42.43,0,5.82,5.82,0,0,0,0,.59,5.72,5.72,0,0,0,0,.59c.24,2.94,2.31,5.82,6.21,8.08,8.28,4.79,21.73,4.79,30,0,3.88-2.26,5.95-5.14,6.19-8.08a5.72,5.72,0,0,0,0-.59A5.82,5.82,0,0,0,360.58,424.41Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.58,405.89h0a21.2,21.2,0,0,0-30.43,18.52,5.82,5.82,0,0,0,0,.59,5.72,5.72,0,0,0,0,.59c.24,2.94,2.31,5.82,6.21,8.08A28.26,28.26,0,0,0,335,437c-5.51-.95-9.07-7.09-7.38-13.88C329.6,415.23,337.56,403.85,348.58,405.89Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.58,425.59a5.72,5.72,0,0,0,0-.59,5.82,5.82,0,0,0,0-.59,21.14,21.14,0,0,0-7.2-15.34c2.3,2.38,7.43,11.31,1.86,18.12-3.67,4.48-21.06,10.87-35.38,2.66a14.75,14.75,0,0,0,4.5,3.82c8.28,4.79,21.73,4.79,30,0C358.27,431.41,360.34,428.53,360.58,425.59Z",
    style: {
      fill: "#F36B1C",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.15,408.55c1,2.17-.87,5.06-4.08,6.47s-6.56.79-7.51-1.38.87-5.05,4.07-6.46S338.2,406.39,339.15,408.55Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.86,417.36a2.79,2.79,0,0,1-5,2.19,2.79,2.79,0,0,1,5-2.19Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.43,374.67A25.3,25.3,0,0,1,266.48,394a16.49,16.49,0,0,0-6,12.57v41.23c0,1.54-1,3.09-3.05,4.26a12.94,12.94,0,0,1-3.83,1.4,17.68,17.68,0,0,1-7.1,0,13,13,0,0,1-3.81-1.4c-2-1.17-3.05-2.72-3.05-4.26V406.45a16.34,16.34,0,0,0-6-12.43,25.25,25.25,0,0,1-9-19.55,25.38,25.38,0,0,1,50.76.2Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.43,374.67A25.3,25.3,0,0,1,266.48,394a16.49,16.49,0,0,0-6,12.57v41.23c0,1.54-1,3.09-3.05,4.26a12.94,12.94,0,0,1-3.83,1.4,17.68,17.68,0,0,1-7.1,0,13,13,0,0,1-3.81-1.4c-2-1.17-3.05-2.72-3.05-4.26V406.45a16.34,16.34,0,0,0-6-12.43,25.25,25.25,0,0,1-9-19.55,25.38,25.38,0,0,1,50.76.2Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.21,374.67a14.14,14.14,0,0,1-6,11.53,11.5,11.5,0,0,0-4.65,9.42v47.29a3.59,3.59,0,0,1-3.51,3.63H250a3.59,3.59,0,0,1-3.52-3.63V395.43a11.32,11.32,0,0,0-4.64-9.24,14.12,14.12,0,0,1-6-11.92,14.16,14.16,0,0,1,28.32.4Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.21,374.67a14.14,14.14,0,0,1-6,11.53,11.5,11.5,0,0,0-4.65,9.42v47.29a3.59,3.59,0,0,1-3.51,3.63H250a3.59,3.59,0,0,1-3.52-3.63V395.43a11.32,11.32,0,0,0-4.64-9.24,14.12,14.12,0,0,1-6-11.92,14.16,14.16,0,0,1,28.32.4Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.64,
    cy: 384.05,
    r: 6.62,
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.59,370.88a4,4,0,1,1,4.05,4A4,4,0,0,1,256.59,370.88Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.87,364.43a2,2,0,1,1,2,2A2,2,0,0,1,248.87,364.43Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.87,366.83a5.44,5.44,0,1,1,5.43,5.44A5.43,5.43,0,0,1,232.87,366.83Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,376.66a2.55,2.55,0,1,0,2.55-2.55A2.55,2.55,0,0,0,232,376.66Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 385.58,
    r: 4.14,
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.74,391.83a3.41,3.41,0,1,1,3.41,3.41A3.41,3.41,0,0,1,243.74,391.83Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.12,370.88a1.74,1.74,0,1,1,1.74,1.73A1.74,1.74,0,0,1,227.12,370.88Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.93,363.69a2.29,2.29,0,1,1,2.29,2.29A2.29,2.29,0,0,1,264.93,363.69Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.21,374.92a2.31,2.31,0,1,1,2.3,2.3A2.31,2.31,0,0,1,267.21,374.92Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,376.78a2.31,2.31,0,1,1,2.3,2.31A2.3,2.3,0,0,1,243.34,376.78Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,125a1.36,1.36,0,0,0-.79.23,36.64,36.64,0,0,0-3,3.87c-2.16,3.26-6.67,9.69-8.26,16.49a9.53,9.53,0,0,0-.24,2.32c-2.75,48.09-.84,82.94-.09,137.17h0c0,1.9,1.67,3.84,5.13,4.94a14.23,14.23,0,0,0,8.11.16c3.5-1,5.28-2.83,5.32-4.73h0c3.06-54.16,6.16-88.91,5.29-137.08a9,9,0,0,0-.14-2.32c-1.32-6.86-5.58-13.46-7.61-16.8a35.84,35.84,0,0,0-2.9-4A1.33,1.33,0,0,0,280,125Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.43,148.75a8.54,8.54,0,0,1-2.94,2.39c-5.1,2.65-13.16,2.31-18-.77a8.45,8.45,0,0,1-2.81-2.77c0,.09,0,.18,0,.28l-.24,4.38a8.26,8.26,0,0,0,2.86,2.85c4.85,3.08,12.91,3.43,18,.77a8,8,0,0,0,3.21-2.8C291.48,151.65,291.46,150.2,291.43,148.75Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.21,125.2a36.64,36.64,0,0,0-3,3.87c-2.16,3.26-6.67,9.69-8.26,16.49a9.53,9.53,0,0,0-.24,2.32c-2.75,48.09-.84,82.94-.09,137.17h0c0,1.7,1.33,3.42,4.09,4.56.19-27.74.61-95.82.54-116.49C272.12,147,278.1,128.83,280,125A1.38,1.38,0,0,0,279.21,125.2Z",
    style: {
      fill: "#084387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.23,297c-4.58,14.83-9.24,29.64-14.2,44.35-.88,2.57.24,5.89,2.69,8a42.59,42.59,0,0,0,28.33,10.05A43.83,43.83,0,0,0,278.38,349c2.44-2.12,3.56-5.38,2.69-7.89-5.05-14.48-9.69-29.09-14.2-43.74Z",
    style: {
      fill: "#084387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05,347.84c-10.31.34-21.92-3.57-29.65-10.54L219,341.37c-.88,2.57.24,5.89,2.69,8a42.85,42.85,0,0,0,28.33,10.05A44.07,44.07,0,0,0,278.38,349c2.44-2.12,3.56-5.38,2.69-7.89-.55-1.58-.82-2.38-1.37-4C271.56,344.29,260.72,347.49,250.05,347.84Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.38,349A44,44,0,0,1,250,359.42c-.71,0-1.41,0-2.09,0s-1.36-.06-2-.11l-1-.1-1.53-.17c-.33,0-.66-.09-1-.15l-1-.17-1.61-.31-.29-.07c-.62-.14-1.23-.3-1.82-.46s-1.45-.42-2.14-.65l-1.2-.43c-.53-.18-1-.39-1.54-.6-1-.4-1.92-.83-2.79-1.26l-.66-.34c-.27-.13-.53-.28-.76-.41s-.73-.41-1.07-.61l-1.11-.68-1.05-.68c-.33-.22-.64-.45-1-.67.73-3.93,1.1-5.91,1.83-9.91A42.12,42.12,0,0,0,233.2,345c-.26,1.93-.59,3.45-.52,3.73C235.4,358.69,259.22,360.46,278.38,349Z",
    style: {
      fill: "#042C71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.37,155.67a24.42,24.42,0,0,0-.49-6c-3.75-17.59-14.68-33.26-20.42-41.51a25.22,25.22,0,0,0-4.38-4.89,3.6,3.6,0,0,0-4.07,0,21.67,21.67,0,0,0-4.37,4.89c-5.38,8.49-16.68,23.92-20.43,41.51a24.42,24.42,0,0,0-.49,6l3.41,156.17h0c0,4.89,4.49,9.79,13.46,12.46a36.87,36.87,0,0,0,20.92,0c9-2.67,13.45-7.57,13.45-12.46h0Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,167.94c0,14.6-1.1,95.65-1.93,154.63,5.91-2.78,8.87-6.76,8.87-10.73h0l3.41-156.17a24.42,24.42,0,0,0-.49-6c-3.75-17.59-14.68-33.26-20.42-41.51-.48-.68-1.06-1.43-1.65-2.14C262.41,120.43,267,144.53,267,167.94Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.51,324.3c9-2.67,13.45-7.57,13.45-12.46h0L276.7,186.4a17.06,17.06,0,0,0-2.61-3.42,3.31,3.31,0,0,0-3.77,0c-.91.63-3.1,4.25-4.15,5.81-5.18,7.63-15.36,22.05-18.83,38.35a22.89,22.89,0,0,0-.46,5.54L250,323.91a7.25,7.25,0,0,0,.26,1.9A37,37,0,0,0,260.51,324.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.08,103.3a3.6,3.6,0,0,0-4.07,0,21.67,21.67,0,0,0-4.37,4.89c-5.38,8.49-16.68,23.92-20.43,41.51a24.42,24.42,0,0,0-.49,6l3.41,156.17c0,4.31,3.49,8.62,10.44,11.41v-91c0-51.8,1.47-86.82,3.75-99.69S249.52,101.93,252.08,103.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,160c11.52,6.65,30.21,6.65,41.73,0a19.67,19.67,0,0,0,6.65-5.9,23.27,23.27,0,0,0-.5-4.4c-.16-.77-.34-1.52-.53-2.28a21.25,21.25,0,0,1-5.62,4.53c-11.52,6.65-30.21,6.65-41.73,0a21.82,21.82,0,0,1-5.34-4.21c-.16.65-.31,1.3-.45,2a24.67,24.67,0,0,0-.5,4.92A20.17,20.17,0,0,0,229,160Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.89,151.7c0,.21,0,.41-.07.62s0,.6-.06.91c0,.1,0,.2,0,.31l0,1.08A20.17,20.17,0,0,0,229,160a35,35,0,0,0,8.77,3.48q.18-4.2.39-7.95A35.53,35.53,0,0,1,229,152a21.82,21.82,0,0,1-5.34-4.21c-.16.65-.31,1.3-.45,2-.09.44-.17.88-.23,1.33C222.94,151.25,222.92,151.48,222.89,151.7Z",
    style: {
      fill: "#084387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,346.06h-8.72c-1.24,7.53,2.76,13.31,4.36,13.31S298.2,353.59,297,346.06Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,346.06h-8.72c-1.24,7.53,2.76,13.31,4.36,13.31S298.2,353.59,297,346.06Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.6,346.06h1.49a6.62,6.62,0,0,1,.81,4c-.18,2-1.4,4.67-2.3,4.67s-2.12-2.64-2.3-4.67a6.62,6.62,0,0,1,.81-4h1.49",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.93,332.52l-9,3.18-.71,3a3.64,3.64,0,0,0,1.63,3.19,5.88,5.88,0,0,0,1.37.75,7.36,7.36,0,0,0,5.21,0,6,6,0,0,0,1.34-.74,3.62,3.62,0,0,0,1.63-3.19Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.93,332.52l-9,3.18-.71,3a3.64,3.64,0,0,0,1.63,3.19,5.88,5.88,0,0,0,1.37.75,7.36,7.36,0,0,0,5.21,0,6,6,0,0,0,1.34-.74,3.62,3.62,0,0,0,1.63-3.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.59,339.61l.3,1.27a4,4,0,0,1-1.79,3.32,6,6,0,0,1-1.47.81,8,8,0,0,1-5.65,0,6.22,6.22,0,0,1-1.5-.82,4,4,0,0,1-1.78-3.33l-.82,3.52h0a4,4,0,0,0,2,3.27,7.16,7.16,0,0,0,1.76.85,10.09,10.09,0,0,0,6.29,0,7.73,7.73,0,0,0,1.73-.85,4,4,0,0,0,2-3.27Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.59,339.61l.3,1.27a4,4,0,0,1-1.79,3.32,6,6,0,0,1-1.47.81,8,8,0,0,1-5.65,0,6.22,6.22,0,0,1-1.5-.82,4,4,0,0,1-1.78-3.33l-.82,3.52h0a4,4,0,0,0,2,3.27,7.16,7.16,0,0,0,1.76.85,10.09,10.09,0,0,0,6.29,0,7.73,7.73,0,0,0,1.73-.85,4,4,0,0,0,2-3.27Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.59,339.59l-.07-.3-.14-.59a3.62,3.62,0,0,1-1.63,3.19,6,6,0,0,1-1.34.74,7.36,7.36,0,0,1-5.21,0,5.88,5.88,0,0,1-1.37-.75,3.64,3.64,0,0,1-1.63-3.19l-.5,2.17a4,4,0,0,0,1.78,3.33,6.22,6.22,0,0,0,1.5.82,8,8,0,0,0,5.65,0,6,6,0,0,0,1.47-.81,4,4,0,0,0,1.79-3.32Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.69,335.75l-.76-3.23-9,3.18-.71,3h0l-.2.89-.3,1.28h0l-.58,2.45C291.26,341.86,295.39,339.14,297.69,335.75Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15,346.06h-8.72c-1.24,7.53,2.76,13.31,4.36,13.31S267.4,353.59,266.15,346.06Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.15,346.06h-8.72c-1.24,7.53,2.76,13.31,4.36,13.31S267.4,353.59,266.15,346.06Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.79,346.06h1.5a6.62,6.62,0,0,1,.81,4c-.18,2-1.41,4.67-2.31,4.67s-2.12-2.64-2.3-4.67a6.62,6.62,0,0,1,.81-4h1.49",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.12,332.52h-8.25l-1.47,6.18a3.61,3.61,0,0,0,1.62,3.19,5.88,5.88,0,0,0,1.37.75,7.36,7.36,0,0,0,5.21,0,5.81,5.81,0,0,0,1.34-.74,3.62,3.62,0,0,0,1.63-3.19Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.12,332.52h-8.25l-1.47,6.18a3.61,3.61,0,0,0,1.62,3.19,5.88,5.88,0,0,0,1.37.75,7.36,7.36,0,0,0,5.21,0,5.81,5.81,0,0,0,1.34-.74,3.62,3.62,0,0,0,1.63-3.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.71,339.29l.07.3.3,1.29a4,4,0,0,1-1.79,3.32,6,6,0,0,1-1.47.81,8,8,0,0,1-5.65,0,6.42,6.42,0,0,1-1.5-.82,4,4,0,0,1-1.78-3.33l-.82,3.52h0a4,4,0,0,0,2,3.27,7.16,7.16,0,0,0,1.76.85,10.09,10.09,0,0,0,6.29,0,7.53,7.53,0,0,0,1.73-.85,4,4,0,0,0,2-3.27Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.71,339.29l.07.3.3,1.29a4,4,0,0,1-1.79,3.32,6,6,0,0,1-1.47.81,8,8,0,0,1-5.65,0,6.42,6.42,0,0,1-1.5-.82,4,4,0,0,1-1.78-3.33l-.82,3.52h0a4,4,0,0,0,2,3.27,7.16,7.16,0,0,0,1.76.85,10.09,10.09,0,0,0,6.29,0,7.53,7.53,0,0,0,1.73-.85,4,4,0,0,0,2-3.27Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.78,339.59l-.07-.3-.14-.59a3.62,3.62,0,0,1-1.63,3.19,5.81,5.81,0,0,1-1.34.74,7.36,7.36,0,0,1-5.21,0,5.88,5.88,0,0,1-1.37-.75,3.61,3.61,0,0,1-1.62-3.19l-.51,2.17a4,4,0,0,0,1.78,3.33,6.42,6.42,0,0,0,1.5.82,8,8,0,0,0,5.65,0,6,6,0,0,0,1.47-.81,4,4,0,0,0,1.79-3.32Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.87,332.52l-.76,3.2c2.28,3.4,6.41,6.12,11.54,7.59l-.94-4-.14-.59h0l-1.45-6.18Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.88,351.55l-8.49-2.2-8.49,2.2a34.3,34.3,0,0,0,.09,11.67c1.11,7.13,6.08,14.26,8.4,14.26s7.28-7.13,8.39-14.26A34.5,34.5,0,0,0,285.88,351.55Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.88,351.55l-8.49-2.2-8.49,2.2a34.3,34.3,0,0,0,.09,11.67c1.11,7.13,6.08,14.26,8.4,14.26s7.28-7.13,8.39-14.26A34.5,34.5,0,0,0,285.88,351.55Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.94,352.58H271.32c-1.66,10,3.67,17.73,5.81,17.73S284.6,362.61,282.94,352.58Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.13,352.58h2a8.74,8.74,0,0,1,1.08,5.36c-.24,2.7-1.87,6.22-3.07,6.22s-2.83-3.52-3.07-6.22a8.82,8.82,0,0,1,1.08-5.36h2",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,342.05l-.94-4h-13l-.93,4a4.83,4.83,0,0,0,2.17,4.25,7.54,7.54,0,0,0,1.83,1,9.76,9.76,0,0,0,6.94,0,7.34,7.34,0,0,0,1.78-1A4.82,4.82,0,0,0,284.84,342.05Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,342.84l.09.39.4,1.72a5.32,5.32,0,0,1-2.37,4.44,8.34,8.34,0,0,1-2,1.07,10.67,10.67,0,0,1-7.53,0,8.4,8.4,0,0,1-2-1.09,5.34,5.34,0,0,1-2.38-4.45l-1.09,4.69h0a5.35,5.35,0,0,0,2.7,4.36,9.31,9.31,0,0,0,2.35,1.14,13.34,13.34,0,0,0,8.38,0,10.11,10.11,0,0,0,2.31-1.13,5.35,5.35,0,0,0,2.7-4.36Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11,343.23l-.09-.39-.18-.79a4.82,4.82,0,0,1-2.18,4.25,7.34,7.34,0,0,1-1.78,1,9.76,9.76,0,0,1-6.94,0,7.54,7.54,0,0,1-1.83-1,4.83,4.83,0,0,1-2.17-4.25l-.68,2.89a5.34,5.34,0,0,0,2.38,4.45,8.4,8.4,0,0,0,2,1.09,10.67,10.67,0,0,0,7.53,0,8.34,8.34,0,0,0,2-1.07,5.32,5.32,0,0,0,2.37-4.44Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.37,344.51a32.67,32.67,0,0,0,7.82-.93l-.08-.35-.09-.39-.18-.79-.94-4h-13l-.93,4-.36,1.54A33,33,0,0,0,277.37,344.51Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.75,315.57l36.51-13.44a36.84,36.84,0,0,0-.16-4.69c0-.48-.1-.94-.16-1.4s-.14-.89-.23-1.31-.2-.88-.32-1.29c-.06-.22-.13-.42-.2-.63s-.09-.32-.15-.47h0a10.62,10.62,0,0,0-4.79-6l-4.68-2.69-.5-.3a13.37,13.37,0,0,0-4.78-1.51,43.59,43.59,0,0,1-10.43-2.51,13.19,13.19,0,0,1-2.64-2.94c-3.56-5.44-4.46-17.13-4.23-22.94l-1,19.82c-3.5-5.5-4.38-17-4.16-22.82l-3.22,62.13,5.44-2v.16Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.26,302.13l-36.51,13.44.26-4.83v-.16L290,273.27l1-19.82c-.23,5.81.67,17.5,4.23,22.94a13.19,13.19,0,0,0,2.64,2.94c3.6,3,9,4.6,15.61,5.5a14.92,14.92,0,0,1,2,.39,12.42,12.42,0,0,1,2.79,1.12,10.62,10.62,0,0,1,4.79,6h0c.06.15.1.31.15.47s.14.41.2.63c.12.41.22.84.32,1.29s.16.86.23,1.31.12.92.16,1.4A36.84,36.84,0,0,1,324.26,302.13Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.24,286.34a12.42,12.42,0,0,0-2.79-1.12,14.92,14.92,0,0,0-2-.39c-6.65-.9-12-2.48-15.61-5.5a43.59,43.59,0,0,0,10.43,2.51,13.37,13.37,0,0,1,4.78,1.51l.5.3Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.3,305.14l34.75-12.8a21.92,21.92,0,0,1,1.06,5.11L288,310.74Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.71,236.31a22.88,22.88,0,0,0-.45-5.54c-3.48-16.3-13.22-29.68-18.84-38.35-1-1.58-3.23-5.18-4.15-5.81a3.28,3.28,0,0,0-1.88-.59,3.33,3.33,0,0,0-1.89.59c-.91.63-3.09,4.25-4.15,5.81-5.18,7.63-15.36,22.05-18.83,38.35a22.89,22.89,0,0,0-.46,5.54l3.17,91.23h0c0,4.54,4.15,9.08,12.46,11.55a34.21,34.21,0,0,0,19.39,0c8.31-2.47,12.47-7,12.47-11.55h0Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.71,236.31a22.88,22.88,0,0,0-.45-5.54c-3.48-16.3-13.22-29.68-18.84-38.35-1-1.58-3.23-5.18-4.15-5.81a3.28,3.28,0,0,0-1.88-.59,3.33,3.33,0,0,0-1.89.59c-.91.63-3.09,4.25-4.15,5.81-5.18,7.63-15.36,22.05-18.83,38.35a22.89,22.89,0,0,0-.46,5.54l3.17,91.23h0c0,4.54,4.15,9.08,12.46,11.55a34.21,34.21,0,0,0,19.39,0c8.31-2.47,12.47-7,12.47-11.55h0Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.55,327.54h0l3.16-91.23a23.39,23.39,0,0,0-.45-5.54c-3.48-16.3-13.22-29.68-18.84-38.35l-.85-1.33c4.61,11.72,11.9,30.5,12.37,56.79.28,15.52-.83,57.13-1.78,88.64C297.41,334,299.55,330.79,299.55,327.54Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.35,192.42c-1.9,2.8-4.49,6.54-7.16,10.94,2.63,1.76,6.18,4.46,13.2,4.46a20,20,0,0,0,13.15-4.39c-2.58-4.21-5.11-7.92-7.12-11-1-1.58-3.23-5.18-4.15-5.81a3.28,3.28,0,0,0-1.88-.59,3.33,3.33,0,0,0-1.89.59C274.59,187.24,272.41,190.86,271.35,192.42Z",
    style: {
      fill: "#084387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.57,191.09c1.55,3.92,3.39,8.66,5.18,14.18,1-.6,1.94-1.24,2.79-1.84-2-3.28-4-6.23-5.7-8.84l-1.42-2.17-.57-.9Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.59,195l-.55.82-.53.8c-.33.48-.66,1-1,1.5l-.49.74-.64,1c-.17.25-.34.51-.5.78l-.66,1c-.34.55-.69,1.1-1,1.67a30.07,30.07,0,0,0,4.78,2.81c3.61-10.18,7.87-20.45,10-19.73a3.61,3.61,0,0,0-.73-.3h-.08a2.88,2.88,0,0,0-.78-.11,3.33,3.33,0,0,0-1.89.59c-.91.63-3.09,4.25-4.15,5.81l-1.21,1.78Z",
    style: {
      fill: "#042C71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.71,219.27a7.2,7.2,0,0,1-.62,5.41,13,13,0,0,1-5.27,5.1,26.73,26.73,0,0,1-8.48,3c-3.47.63-6.47,3.42-6.62,6.94l-.06,1.45c-.15,3.53,2.6,6.43,6.09,5.91a33,33,0,0,0,11.46-3.79c5-2.89,7.45-6.68,7.37-10.46a8.47,8.47,0,0,0-.45-2.61A73.31,73.31,0,0,0,298.71,219.27Z",
    style: {
      fill: "#084387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.58,232.87c-.08-.7-.18-1.4-.32-2.1-.1-.45-.22-.89-.32-1.34-.16-.67-.32-1.34-.5-2l-.21-.73c-.2-.7-.4-1.4-.61-2.09s-.44-1.3-.66-1.94c-.09-.25-.17-.51-.25-.75-.32-.88-.65-1.74-1-2.59a7.19,7.19,0,0,1-.63,5.35,12.59,12.59,0,0,1-4.66,4.72c.65,4.41,1.12,9.1,1.36,14.08l.42-.21C300.17,240.4,302.63,236.63,302.58,232.87Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.57,336.6c0-2.08-4.73-25.67-11.6-31.66a2.43,2.43,0,0,0-2.52-.45,6,6,0,0,0-2.21,1.81,31.42,31.42,0,0,0-6.67,19.89v10.92l9.6,3.7a14.67,14.67,0,0,0,11.14-.71,4.07,4.07,0,0,0,2.24-3.5Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.44,334.19a3.92,3.92,0,0,0,2.13-3.26c-.23-1.08-.51-2.27-.83-3.53v0h0a3.74,3.74,0,0,1-2.06,3.22,13.51,13.51,0,0,1-10.26.65l-8.84-3.4v3.42l9.21,3.54A14.05,14.05,0,0,0,302.44,334.19Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.48,304.49a5.93,5.93,0,0,0-2.24,1.81,31.45,31.45,0,0,0-6.67,19.9v10.91l9.6,3.7a12.34,12.34,0,0,0,2.77.66C293.21,330.93,289.59,307.28,291.48,304.49Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,335.41c-.18-1.16-.37-2.37-.55-3.61a10.12,10.12,0,0,1-2-.51l-8.84-3.4v3.42l9.21,3.54A11.06,11.06,0,0,0,294,335.41Z",
    style: {
      fill: "#084387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.22,335.84l-8.49-2.2-8.49,2.2a34.5,34.5,0,0,0,.1,11.67c1.11,7.12,6.07,14.25,8.39,14.25s7.29-7.13,8.4-14.25A34.3,34.3,0,0,0,227.22,335.84Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.22,335.84l-8.49-2.2-8.49,2.2a34.5,34.5,0,0,0,.1,11.67c1.11,7.12,6.07,14.25,8.39,14.25s7.29-7.13,8.4-14.25A34.3,34.3,0,0,0,227.22,335.84Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.29,336.86H212.67c-1.66,10,3.67,17.74,5.81,17.74S226,346.9,224.29,336.86Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.48,336.86h2a8.85,8.85,0,0,1,1.08,5.36c-.24,2.71-1.87,6.23-3.07,6.23s-2.83-3.52-3.07-6.23a8.77,8.77,0,0,1,1.08-5.36h2",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.18,326.34l-.93-4h-13l-.94,4a4.85,4.85,0,0,0,2.18,4.25,7.83,7.83,0,0,0,1.82,1,9.84,9.84,0,0,0,6.95,0,7.7,7.7,0,0,0,1.78-1A4.82,4.82,0,0,0,226.18,326.34Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.37,327.13l.09.39.4,1.72a5.32,5.32,0,0,1-2.38,4.43,8.68,8.68,0,0,1-2,1.08,10.67,10.67,0,0,1-7.53,0,8.07,8.07,0,0,1-2-1.09,5.31,5.31,0,0,1-2.38-4.44l-1.1,4.69h0a5.35,5.35,0,0,0,2.7,4.36,9.84,9.84,0,0,0,2.35,1.14,13.44,13.44,0,0,0,8.39,0,9.84,9.84,0,0,0,2.3-1.13,5.33,5.33,0,0,0,2.7-4.36Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.46,327.52l-.09-.39-.19-.79a4.82,4.82,0,0,1-2.17,4.25,7.7,7.7,0,0,1-1.78,1,9.84,9.84,0,0,1-6.95,0,7.83,7.83,0,0,1-1.82-1,4.85,4.85,0,0,1-2.18-4.25l-.67,2.89a5.31,5.31,0,0,0,2.38,4.44,8.07,8.07,0,0,0,2,1.09,10.67,10.67,0,0,0,7.53,0,8.68,8.68,0,0,0,2-1.08,5.32,5.32,0,0,0,2.38-4.43Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.73,330.53c2.76,0,6.72-.88,7.81-2.66l-.08-.35-.09-.39-.19-.79-.93-4h-13l-.94,4-.36,1.54C211.68,329.73,216,330.53,218.73,330.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.65,161.7a1.47,1.47,0,0,1,.8.23,37.11,37.11,0,0,1,3.05,3.88c2.15,3.25,6.67,9.68,8.26,16.48a9.05,9.05,0,0,1,.23,2.32c2.76,48.1.85,82.94.1,137.18h0c0,1.9-1.67,3.83-5.13,4.94a14.37,14.37,0,0,1-4.05.67,14.68,14.68,0,0,1-4.06-.51c-3.51-1-5.29-2.84-5.32-4.74h0c-3.07-54.16-6.16-88.91-5.3-137.07a9.59,9.59,0,0,1,.15-2.33c1.32-6.86,5.58-13.46,7.6-16.8a38.2,38.2,0,0,1,2.9-4,1.49,1.49,0,0,1,.79-.26Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.39,326.57c3.16-1.12,4.73-3,4.7-4.78h0c.75-54.24,2.66-89.08-.1-137.18a9.05,9.05,0,0,0-.23-2.32c-1.59-6.8-6.11-13.23-8.26-16.48a37.11,37.11,0,0,0-3.05-3.88c3.67,8.72,5.59,23.42,6.26,49.81C223.19,230.31,223.34,291.77,223.39,326.57Z",
    style: {
      fill: "#084387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.1,192.2a7.79,7.79,0,0,0,3.14-3c-.07-1.43-.15-2.87-.23-4.33a8.37,8.37,0,0,1-2.91,2.62c-5,2.87-13,2.87-18,0a8.65,8.65,0,0,1-2.85-2.54v.16c0,1.52,0,3-.07,4.51a8.29,8.29,0,0,0,2.92,2.61C212.06,195.08,220.13,195.08,225.1,192.2Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.34,199.11a4.37,4.37,0,0,1,2,3.43c0,1.26-.89,1.77-2,1.14a4.39,4.39,0,0,1-2-3.43C206.36,199,207.25,198.48,208.34,199.11Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.26,207.23a4.14,4.14,0,0,1,1.88,3.25c0,1.2-.84,1.68-1.88,1.08a4.14,4.14,0,0,1-1.87-3.25C206.39,207.12,207.23,206.63,208.26,207.23Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.36,215.35a4,4,0,0,1,1.78,3.08c0,1.13-.8,1.59-1.78,1a3.9,3.9,0,0,1-1.77-3.07C206.59,215.25,207.38,214.79,208.36,215.35Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.58,223.48a3.7,3.7,0,0,1,1.68,2.9c0,1.07-.75,1.5-1.68,1a3.7,3.7,0,0,1-1.67-2.89C206.91,223.38,207.66,223,208.58,223.48Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.89,231.61a3.49,3.49,0,0,1,1.57,2.72c0,1-.71,1.41-1.57.91a3.46,3.46,0,0,1-1.57-2.72C207.32,231.52,208,231.11,208.89,231.61Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.23,239.74a3.24,3.24,0,0,1,1.47,2.54c0,.94-.66,1.31-1.47.85a3.26,3.26,0,0,1-1.47-2.55C207.76,239.65,208.42,239.27,209.23,239.74Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.56,247.86a3,3,0,0,1,1.37,2.36c0,.88-.61,1.23-1.37.79a3,3,0,0,1-1.36-2.36C208.2,247.78,208.81,247.42,209.56,247.86Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.81,330.41l-36.5,28.71-5.16-3c-.28-10.57,3.15-19.91,10.8-29.77,3.25-4.2,6.24-8.11,8.92-11.81a128.05,128.05,0,0,0,10.58-16.65c4.4-8.68,5.49-20.07,5.42-26.06a4,4,0,0,0,0-.6c0-.2,0-.39,0-.57l2.74,1.34Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.36,299.84c-3.27,8.77-9.7,18.48-18.25,29.51-7.65,9.87-11.08,19.19-10.8,29.77l-5.16-3c-.28-10.57,3.15-19.91,10.8-29.77,3.25-4.2,6.24-8.11,8.92-11.81a128.05,128.05,0,0,0,10.58-16.65c4.4-8.68,5.49-20.07,5.42-26.06a4,4,0,0,0,0-.6c0-.2,0-.39,0-.57l2.74,1.34C258.81,277.56,257.92,290.28,254.36,299.84Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.35,345a40.53,40.53,0,0,0-1,6.31l5.15,3,0-.16a40.6,40.6,0,0,1,1-6.11v0Z",
    style: {
      fill: "#084387"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.59,272c.22,5.55-.67,18.28-4.23,27.83-3.27,8.78-9.7,18.49-18.25,29.51-7.65,9.86-11.09,19.2-10.8,29.77l36.5-28.71Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.27,320.62,226.51,348a38.44,38.44,0,0,0-1.06,6.32l36.11-28.4Z",
    style: {
      fill: "#0B6AB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.36,430.51a12.93,12.93,0,0,0-25.86,0,2.11,2.11,0,0,0,0,.36,2.23,2.23,0,0,0,0,.36c.14,1.79,1.4,3.55,3.78,4.92,5.05,2.92,13.25,2.92,18.3,0,2.37-1.37,3.63-3.13,3.78-4.92,0-.13,0-.24,0-.36S385.37,430.63,385.36,430.51Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.36,430.51a12.93,12.93,0,0,0-25.86,0,2.11,2.11,0,0,0,0,.36,2.23,2.23,0,0,0,0,.36c.14,1.79,1.4,3.55,3.78,4.92,5.05,2.92,13.25,2.92,18.3,0,2.37-1.37,3.63-3.13,3.78-4.92,0-.13,0-.24,0-.36S385.37,430.63,385.36,430.51Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,419.22h0a12.92,12.92,0,0,0-18.54,11.29,2.11,2.11,0,0,0,0,.36,2.23,2.23,0,0,0,0,.36c.14,1.79,1.4,3.55,3.78,4.92a17,17,0,0,0,6.49,2c-3.36-.57-5.53-4.32-4.49-8.46C366.47,424.91,371.32,418,378,419.22Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.36,431.23c0-.13,0-.24,0-.36s0-.24,0-.36a12.89,12.89,0,0,0-4.39-9.35c1.4,1.44,4.53,6.89,1.13,11-2.23,2.73-12.84,6.63-21.56,1.62a9,9,0,0,0,2.74,2.33c5.05,2.92,13.25,2.92,18.3,0C384,434.78,385.21,433,385.36,431.23Z",
    style: {
      fill: "#F36B1C",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.29,420.84c.58,1.32-.53,3.08-2.48,3.94s-4,.48-4.58-.84.53-3.08,2.48-3.93S371.72,419.52,372.29,420.84Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.8,426.21a1.53,1.53,0,0,1-1,1.91,1.39,1.39,0,1,1,1-1.91Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.57,440.23a17.81,17.81,0,0,0-35.61,0c0,.17,0,.32,0,.49s0,.33,0,.5c.2,2.46,1.94,4.88,5.21,6.78,6.95,4,18.24,4,25.21,0,3.25-1.9,5-4.32,5.19-6.78a4.18,4.18,0,0,0,0-.5A4,4,0,0,0,365.57,440.23Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.57,440.23a17.81,17.81,0,0,0-35.61,0c0,.17,0,.32,0,.49s0,.33,0,.5c.2,2.46,1.94,4.88,5.21,6.78,6.95,4,18.24,4,25.21,0,3.25-1.9,5-4.32,5.19-6.78a4.18,4.18,0,0,0,0-.5A4,4,0,0,0,365.57,440.23Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.49,424.68h0A17.78,17.78,0,0,0,330,440.23c0,.17,0,.32,0,.49s0,.33,0,.5c.2,2.46,1.94,4.88,5.21,6.78a23.74,23.74,0,0,0,8.94,2.78c-4.62-.79-7.61-5.95-6.19-11.65C339.57,432.52,346.25,423,355.49,424.68Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.57,441.22a4.18,4.18,0,0,0,0-.5,4,4,0,0,0,0-.49,17.71,17.71,0,0,0-6.05-12.88c1.94,2,6.24,9.49,1.57,15.21-3.08,3.76-17.68,9.12-29.7,2.23a12.53,12.53,0,0,0,3.78,3.21c6.95,4,18.24,4,25.21,0C363.63,446.1,365.37,443.68,365.57,441.22Z",
    style: {
      fill: "#F36B1C",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.58,426.92c.8,1.81-.73,4.24-3.42,5.42s-5.51.67-6.31-1.15.74-4.24,3.43-5.42S346.79,425.1,347.58,426.92Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.27,434.31a2.34,2.34,0,1,1-2.85-.79A2.12,2.12,0,0,1,337.27,434.31Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.82,446.56a22.11,22.11,0,0,0-44.2,0c0,.21,0,.4,0,.61s0,.41,0,.62c.25,3.06,2.41,6.06,6.47,8.41,8.62,5,22.64,5,31.28,0,4-2.35,6.2-5.35,6.45-8.41,0-.21,0-.41,0-.62S333.84,446.77,333.82,446.56Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.82,446.56a22.11,22.11,0,0,0-44.2,0c0,.21,0,.4,0,.61s0,.41,0,.62c.25,3.06,2.41,6.06,6.47,8.41,8.62,5,22.64,5,31.28,0,4-2.35,6.2-5.35,6.45-8.41,0-.21,0-.41,0-.62S333.84,446.77,333.82,446.56Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.31,427.26h0a22.09,22.09,0,0,0-31.69,19.3c0,.21,0,.4,0,.61s0,.41,0,.62c.25,3.06,2.41,6.06,6.47,8.41a29.46,29.46,0,0,0,11.09,3.46c-5.73-1-9.44-7.39-7.68-14.46C301.55,437,309.84,425.14,321.31,427.26Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.82,447.79c0-.21,0-.41,0-.62s0-.4,0-.61a22,22,0,0,0-7.5-16c2.4,2.47,7.74,11.78,1.93,18.87-3.81,4.67-21.94,11.33-36.85,2.77a15.49,15.49,0,0,0,4.69,4c8.62,5,22.64,5,31.28,0C331.41,453.85,333.57,450.85,333.82,447.79Z",
    style: {
      fill: "#F36B1C",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.5,430c1,2.25-.92,5.27-4.25,6.73s-6.84.83-7.83-1.43.91-5.26,4.25-6.73S310.51,427.79,311.5,430Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.69,439.21a2.9,2.9,0,1,1-3.54-1A2.62,2.62,0,0,1,298.69,439.21Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.3,433.54a7.81,7.81,0,0,0-15.62,0,1.55,1.55,0,0,0,0,.22,1.48,1.48,0,0,0,0,.21,4,4,0,0,0,2.28,3A12.24,12.24,0,0,0,394,437a4,4,0,0,0,2.28-3,1.48,1.48,0,0,0,0-.21A1.55,1.55,0,0,0,396.3,433.54Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.3,433.54a7.81,7.81,0,0,0-15.62,0,1.55,1.55,0,0,0,0,.22,1.48,1.48,0,0,0,0,.21,4,4,0,0,0,2.28,3A12.24,12.24,0,0,0,394,437a4,4,0,0,0,2.28-3,1.48,1.48,0,0,0,0-.21A1.55,1.55,0,0,0,396.3,433.54Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.88,426.72h0a7.8,7.8,0,0,0-11.2,6.82,1.55,1.55,0,0,0,0,.22,1.48,1.48,0,0,0,0,.21,4,4,0,0,0,2.28,3,10.48,10.48,0,0,0,3.92,1.22c-2-.35-3.34-2.61-2.71-5.11C384.89,430.16,387.82,426,391.88,426.72Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.3,434a1.48,1.48,0,0,0,0-.21,1.55,1.55,0,0,0,0-.22,7.78,7.78,0,0,0-2.65-5.65c.85.87,2.74,4.16.68,6.67-1.35,1.65-7.75,4-13,1A5.51,5.51,0,0,0,383,437,12.24,12.24,0,0,0,394,437,4,4,0,0,0,396.3,434Z",
    style: {
      fill: "#0B6AB0",
      opacity: 0.05,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.41,427.7c.35.79-.32,1.86-1.5,2.38s-2.42.29-2.77-.51.32-1.86,1.5-2.38S388.06,426.9,388.41,427.7Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.88,430.94a1,1,0,1,1-1.25-.35A.93.93,0,0,1,383.88,430.94Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.64,424.13a12.93,12.93,0,0,1,25.86,0,2.23,2.23,0,0,1,0,.36,2.11,2.11,0,0,1,0,.36c-.14,1.79-1.4,3.55-3.78,4.93-5.05,2.91-13.25,2.91-18.3,0-2.37-1.38-3.63-3.14-3.78-4.93,0-.12,0-.23,0-.36S114.63,424.26,114.64,424.13Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.64,424.13a12.93,12.93,0,0,1,25.86,0,2.23,2.23,0,0,1,0,.36,2.11,2.11,0,0,1,0,.36c-.14,1.79-1.4,3.55-3.78,4.93-5.05,2.91-13.25,2.91-18.3,0-2.37-1.38-3.63-3.14-3.78-4.93,0-.12,0-.23,0-.36S114.63,424.26,114.64,424.13Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,412.84h0a12.92,12.92,0,0,1,18.54,11.29,2.23,2.23,0,0,1,0,.36,2.11,2.11,0,0,1,0,.36c-.14,1.79-1.4,3.55-3.78,4.93a17.34,17.34,0,0,1-6.49,2c3.36-.58,5.53-4.32,4.5-8.46C133.53,418.54,128.68,411.6,122,412.84Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.64,424.85c0-.12,0-.23,0-.36s0-.23,0-.36a12.86,12.86,0,0,1,4.39-9.34c-1.4,1.44-4.53,6.89-1.13,11,2.23,2.73,12.84,6.62,21.56,1.62a9.1,9.1,0,0,1-2.74,2.33c-5.05,2.91-13.25,2.91-18.3,0C116.05,428.4,114.79,426.64,114.64,424.85Z",
    style: {
      fill: "#F36B1C",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.71,414.47c-.58,1.32.53,3.08,2.48,3.94s4,.48,4.58-.84-.53-3.08-2.48-3.94S128.28,413.15,127.71,414.47Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.2,419.83a1.7,1.7,0,1,0,2.07-.57A1.54,1.54,0,0,0,135.2,419.83Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.32,422.78a18.76,18.76,0,0,1,37.51,0c0,.18,0,.34,0,.52s0,.35,0,.53c-.21,2.59-2,5.14-5.49,7.13-7.32,4.24-19.21,4.24-26.55,0-3.43-2-5.26-4.54-5.47-7.13a4.7,4.7,0,0,1,0-.53A4.52,4.52,0,0,1,153.32,422.78Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.32,422.78a18.76,18.76,0,0,1,37.51,0c0,.18,0,.34,0,.52s0,.35,0,.53c-.21,2.59-2,5.14-5.49,7.13-7.32,4.24-19.21,4.24-26.55,0-3.43-2-5.26-4.54-5.47-7.13a4.7,4.7,0,0,1,0-.53A4.52,4.52,0,0,1,153.32,422.78Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.93,406.4h0a18.75,18.75,0,0,1,26.9,16.38c0,.18,0,.34,0,.52s0,.35,0,.53c-.21,2.59-2,5.14-5.49,7.13a24.81,24.81,0,0,1-9.41,2.94c4.86-.84,8-6.27,6.52-12.27C180.71,414.67,173.67,404.61,163.93,406.4Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.32,423.83a4.7,4.7,0,0,1,0-.53,4.52,4.52,0,0,1,0-.52,18.65,18.65,0,0,1,6.37-13.56c-2,2.1-6.58,10-1.65,16,3.24,4,18.62,9.61,31.28,2.35a13.06,13.06,0,0,1-4,3.37c-7.32,4.24-19.21,4.24-26.55,0C155.36,429,153.53,426.42,153.32,423.83Z",
    style: {
      fill: "#F36B1C",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.26,408.76c-.84,1.91.78,4.47,3.61,5.71s5.8.7,6.64-1.21-.77-4.47-3.6-5.71S173.1,406.85,172.26,408.76Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.13,416.55a2.46,2.46,0,1,0,3-.84A2.22,2.22,0,0,0,183.13,416.55Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.8,433.79a17.81,17.81,0,0,1,35.61,0,4.18,4.18,0,0,1,0,.5,4,4,0,0,1,0,.49c-.2,2.47-1.94,4.89-5.21,6.78-6.95,4-18.24,4-25.2,0-3.26-1.89-5-4.31-5.2-6.78a4,4,0,0,1,0-.49A4.18,4.18,0,0,1,136.8,433.79Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.8,433.79a17.81,17.81,0,0,1,35.61,0,4.18,4.18,0,0,1,0,.5,4,4,0,0,1,0,.49c-.2,2.47-1.94,4.89-5.21,6.78-6.95,4-18.24,4-25.2,0-3.26-1.89-5-4.31-5.2-6.78a4,4,0,0,1,0-.49A4.18,4.18,0,0,1,136.8,433.79Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.88,418.25h0a17.78,17.78,0,0,1,25.53,15.54,4.18,4.18,0,0,1,0,.5,4,4,0,0,1,0,.49c-.2,2.47-1.94,4.89-5.21,6.78a23.58,23.58,0,0,1-8.94,2.79c4.62-.8,7.61-6,6.19-11.65C162.8,426.09,156.12,416.54,146.88,418.25Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.8,434.78a4,4,0,0,1,0-.49,4.18,4.18,0,0,1,0-.5,17.69,17.69,0,0,1,6-12.87c-1.94,2-6.24,9.49-1.57,15.2,3.08,3.76,17.68,9.13,29.7,2.23a12.26,12.26,0,0,1-3.78,3.21c-6.95,4-18.24,4-25.2,0C138.74,439.67,137,437.25,136.8,434.78Z",
    style: {
      fill: "#F36B1C",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.79,420.48c-.8,1.82.73,4.25,3.42,5.43s5.51.66,6.31-1.15-.74-4.25-3.43-5.43S155.58,418.67,154.79,420.48Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.1,427.87a2.34,2.34,0,1,0,2.85-.79A2.12,2.12,0,0,0,165.1,427.87Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.81,443.89a22.1,22.1,0,0,1,44.19,0c0,.21,0,.4,0,.62s0,.4,0,.61c-.25,3.06-2.4,6.06-6.47,8.41-8.62,5-22.63,5-31.28,0-4-2.35-6.19-5.35-6.44-8.41,0-.21,0-.4,0-.61S169.79,444.1,169.81,443.89Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.81,443.89a22.1,22.1,0,0,1,44.19,0c0,.21,0,.4,0,.62s0,.4,0,.61c-.25,3.06-2.4,6.06-6.47,8.41-8.62,5-22.63,5-31.28,0-4-2.35-6.19-5.35-6.44-8.41,0-.21,0-.4,0-.61S169.79,444.1,169.81,443.89Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.31,424.6h0A22.07,22.07,0,0,1,214,443.89c0,.21,0,.4,0,.62s0,.4,0,.61c-.25,3.06-2.4,6.06-6.47,8.41A29.4,29.4,0,0,1,196.44,457c5.74-1,9.45-7.39,7.68-14.46C202.08,434.33,193.79,422.48,182.31,424.6Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.81,445.12c0-.21,0-.4,0-.61s0-.41,0-.62a22,22,0,0,1,7.5-16c-2.4,2.47-7.74,11.77-1.94,18.86,3.82,4.67,21.94,11.33,36.85,2.77a15.23,15.23,0,0,1-4.69,4c-8.62,5-22.63,5-31.28,0C172.21,451.18,170.06,448.18,169.81,445.12Z",
    style: {
      fill: "#F36B1C",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.13,427.37c-1,2.26.91,5.27,4.24,6.73s6.84.83,7.83-1.42-.91-5.27-4.24-6.74S193.12,425.12,192.13,427.37Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.93,436.54a2.9,2.9,0,1,0,3.54-1A2.63,2.63,0,0,0,204.93,436.54Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.63,447.86a20.18,20.18,0,0,0-40.35,0,7.85,7.85,0,0,0,0,1.12c.23,2.8,2.2,5.54,5.91,7.68,7.87,4.55,20.66,4.55,28.55,0,3.69-2.14,5.66-4.88,5.89-7.68a7.85,7.85,0,0,0,0-1.12Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.63,447.86a20.18,20.18,0,0,0-40.35,0,7.85,7.85,0,0,0,0,1.12c.23,2.8,2.2,5.54,5.91,7.68,7.87,4.55,20.66,4.55,28.55,0,3.69-2.14,5.66-4.88,5.89-7.68a7.85,7.85,0,0,0,0-1.12Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.21,430.24h0a20.16,20.16,0,0,0-28.93,17.62,7.85,7.85,0,0,0,0,1.12c.23,2.8,2.2,5.54,5.91,7.68a26.9,26.9,0,0,0,10.12,3.16c-5.23-.9-8.62-6.75-7-13.2C264.16,439.13,271.73,428.31,282.21,430.24Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.63,449a7.85,7.85,0,0,0,0-1.12,20.1,20.1,0,0,0-6.85-14.59c2.19,2.26,7.07,10.75,1.77,17.23-3.49,4.26-20,10.34-33.65,2.53a14.1,14.1,0,0,0,4.29,3.63c7.87,4.55,20.66,4.55,28.55,0C291.43,454.52,293.4,451.78,293.63,449Z",
    style: {
      fill: "#F36B1C",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.74,
    cy: 435.2,
    rx: 6.02,
    ry: 4.07,
    transform: "translate(-152.39 144.38) rotate(-23.71)",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.56,441.15a2.66,2.66,0,1,1-3.23-.89A2.4,2.4,0,0,1,261.56,441.15Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.36,450.05a19.2,19.2,0,0,1,38.38,0c0,.18,0,.35,0,.54s0,.35,0,.53c-.22,2.66-2.09,5.27-5.62,7.3-7.49,4.33-19.65,4.33-27.16,0-3.51-2-5.38-4.64-5.6-7.3,0-.18,0-.35,0-.53S209.35,450.23,209.36,450.05Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.36,450.05a19.2,19.2,0,0,1,38.38,0c0,.18,0,.35,0,.54s0,.35,0,.53c-.22,2.66-2.09,5.27-5.62,7.3-7.49,4.33-19.65,4.33-27.16,0-3.51-2-5.38-4.64-5.6-7.3,0-.18,0-.35,0-.53S209.35,450.23,209.36,450.05Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,433.3h0a19.17,19.17,0,0,1,27.52,16.75c0,.18,0,.35,0,.54s0,.35,0,.53c-.22,2.66-2.09,5.27-5.62,7.3a25.5,25.5,0,0,1-9.63,3c5-.86,8.2-6.42,6.67-12.56C237.39,441.75,230.19,431.46,220.22,433.3Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.36,451.12c0-.18,0-.35,0-.53s0-.36,0-.54a19.14,19.14,0,0,1,6.52-13.87c-2.09,2.15-6.72,10.23-1.68,16.39,3.31,4.05,19,9.83,32,2.4a13.3,13.3,0,0,1-4.07,3.45c-7.49,4.33-19.65,4.33-27.16,0C211.45,456.39,209.58,453.78,209.36,451.12Z",
    style: {
      fill: "#F36B1C",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.75,435.71c-.86,2,.79,4.57,3.68,5.84s5.94.72,6.8-1.24-.79-4.57-3.69-5.84S229.6,433.75,228.75,435.71Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.86,443.67a2.53,2.53,0,1,0,3.08-.85A2.29,2.29,0,0,0,239.86,443.67Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.15,456.76a7.82,7.82,0,0,0-15.63,0v.44a4,4,0,0,0,2.29,3,12.24,12.24,0,0,0,11.06,0,4,4,0,0,0,2.28-3,1.7,1.7,0,0,0,0-.22A1.55,1.55,0,0,0,259.15,456.76Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.15,456.76a7.82,7.82,0,0,0-15.63,0v.44a4,4,0,0,0,2.29,3,12.24,12.24,0,0,0,11.06,0,4,4,0,0,0,2.28-3,1.7,1.7,0,0,0,0-.22A1.55,1.55,0,0,0,259.15,456.76Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.73,449.94h0a7.74,7.74,0,0,0-3.39-.78,7.82,7.82,0,0,0-7.82,7.6v.44a4,4,0,0,0,2.29,3,10.48,10.48,0,0,0,3.92,1.22c-2-.35-3.34-2.61-2.71-5.11C247.74,453.38,250.67,449.19,254.73,449.94Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.6000000000000001,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.15,457.2a1.7,1.7,0,0,0,0-.22,1.55,1.55,0,0,0,0-.22,7.78,7.78,0,0,0-2.65-5.65c.85.88,2.74,4.17.68,6.67-1.35,1.65-7.75,4-13,1a5.51,5.51,0,0,0,1.66,1.41,12.24,12.24,0,0,0,11.06,0A4,4,0,0,0,259.15,457.2Z",
    style: {
      fill: "#F36B1C",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.26,450.92c.35.8-.32,1.86-1.5,2.38s-2.42.29-2.77-.5.32-1.87,1.5-2.39S250.91,450.12,251.26,450.92Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.73,454.16a1,1,0,1,1-1.25-.34A.93.93,0,0,1,246.73,454.16Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.7,427.16a7.82,7.82,0,0,1,15.63,0v.44a4,4,0,0,1-2.29,3,12.18,12.18,0,0,1-11.06,0,4,4,0,0,1-2.28-3,1.62,1.62,0,0,1,0-.22A1.7,1.7,0,0,1,103.7,427.16Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.7,427.16a7.82,7.82,0,0,1,15.63,0v.44a4,4,0,0,1-2.29,3,12.18,12.18,0,0,1-11.06,0,4,4,0,0,1-2.28-3,1.62,1.62,0,0,1,0-.22A1.7,1.7,0,0,1,103.7,427.16Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.12,420.34h0a7.81,7.81,0,0,1,11.21,6.82v.44a4,4,0,0,1-2.29,3,10.49,10.49,0,0,1-3.92,1.23c2-.35,3.34-2.62,2.71-5.12C115.11,423.78,112.18,419.59,108.12,420.34Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.5,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.7,427.6a1.62,1.62,0,0,1,0-.22,1.7,1.7,0,0,1,0-.22,7.74,7.74,0,0,1,2.65-5.64c-.85.87-2.74,4.16-.68,6.67,1.35,1.65,7.75,4,13,1a5.49,5.49,0,0,1-1.66,1.4,12.18,12.18,0,0,1-11.06,0A4,4,0,0,1,103.7,427.6Z",
    style: {
      fill: "#0B6AB0",
      opacity: 0.05,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.59,421.32c-.35.8.32,1.87,1.5,2.38s2.42.3,2.77-.5-.32-1.86-1.5-2.38S111.94,420.53,111.59,421.32Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.12,424.57a1,1,0,1,0,1.25-.35A.92.92,0,0,0,116.12,424.57Z",
    style: {
      fill: "#f4f4f4",
      opacity: 0.30000000000000004,
      mixBlendMode: "lighten"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-1--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-1--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.69,248.3a1.56,1.56,0,1,1-1.56-1.56A1.55,1.55,0,0,1,181.69,248.3Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.44,
    cy: 223.71,
    r: 1.56,
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.47,105.15a1.56,1.56,0,1,1-1.56-1.56A1.56,1.56,0,0,1,208.47,105.15Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.19,151.07a1.56,1.56,0,1,1-1.55-1.55A1.55,1.55,0,0,1,62.19,151.07Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.23,259.06a1.68,1.68,0,1,1-1.68-1.68A1.68,1.68,0,0,1,327.23,259.06Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.92,262a.84.84,0,1,1-.84-.84A.84.84,0,0,1,331.92,262Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,311.48a.84.84,0,1,1-.84-.84A.85.85,0,0,1,378,311.48Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.27,318.33a1.68,1.68,0,1,1-1.68-1.67A1.68,1.68,0,0,1,375.27,318.33Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.58,187.75a.84.84,0,0,1-.62,1.56.84.84,0,0,1,.62-1.56Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,192.83a1.68,1.68,0,1,1-2.18.94A1.67,1.67,0,0,1,449,192.83Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.35,131.82a.84.84,0,1,1-.62,1.56.84.84,0,0,1,.62-1.56Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.72,136.9a1.68,1.68,0,1,1-2.17.95A1.68,1.68,0,0,1,330.72,136.9Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.14,123.26a1.68,1.68,0,1,1-2.17.95A1.68,1.68,0,0,1,412.14,123.26Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5,89.48a.78.78,0,1,1-1,.44A.78.78,0,0,1,91.5,89.48Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.49,94.2a1.56,1.56,0,1,1-2,.88A1.56,1.56,0,0,1,96.49,94.2Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.48,226.53a.78.78,0,1,1-.78-.78A.78.78,0,0,1,129.48,226.53Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.02,
    cy: 223.21,
    r: 1.56,
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.22,195.89a1.77,1.77,0,1,1-1.76-1.76A1.76,1.76,0,0,1,334.22,195.89Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,200.71a1.05,1.05,0,1,1-1.05-1.05A1,1,0,0,1,329,200.71Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,194.13a.85.85,0,1,1-.85-.85A.85.85,0,0,1,326,194.13Z",
    style: {
      fill: "#f4f4f4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.64,87.9a1.76,1.76,0,1,1-1.76-1.76A1.76,1.76,0,0,1,294.64,87.9Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.37,92.72a1.05,1.05,0,1,1-1.05-1A1,1,0,0,1,289.37,92.72Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.39,86.14a.85.85,0,1,1-.85-.85A.85.85,0,0,1,286.39,86.14Z",
    style: {
      fill: "#f4f4f4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.51,128a1.76,1.76,0,1,1-2.48-.31A1.76,1.76,0,0,1,72.51,128Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3,135a1.05,1.05,0,0,1-1.66,1.29A1.05,1.05,0,1,1,71.3,135Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.91,131.62a.85.85,0,1,1-1.2-.15A.86.86,0,0,1,64.91,131.62Z",
    style: {
      fill: "#f4f4f4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.59,334.57a1.75,1.75,0,0,1,.61,2.41,1.76,1.76,0,1,1-.61-2.41Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,341.56a1.05,1.05,0,0,1-1.08,1.81,1.05,1.05,0,0,1,1.08-1.81Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85,340.75a.86.86,0,0,1,.29,1.17.85.85,0,1,1-.29-1.17Z",
    style: {
      fill: "#f4f4f4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M378.33,159.75a1.68,1.68,0,1,1-1.68-1.68A1.69,1.69,0,0,1,378.33,159.75Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.34,178.1l-3.29,1.14-.93,3.36a.4.4,0,0,1-.7.14l-2.1-2.78-3.48.15a.39.39,0,0,1-.34-.62l2-2.86-1.22-3.26a.4.4,0,0,1,.49-.52l3.33,1,2.72-2.18a.4.4,0,0,1,.64.31l.07,3.48,2.91,1.92A.39.39,0,0,1,402.34,178.1Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.3,84.79,344,85.93l-.93,3.36a.4.4,0,0,1-.7.13l-2.1-2.78-3.48.16a.4.4,0,0,1-.34-.62l2-2.86-1.22-3.26a.4.4,0,0,1,.49-.52l3.33,1,2.72-2.17a.4.4,0,0,1,.65.3l.06,3.48,2.91,1.92A.4.4,0,0,1,347.3,84.79Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.9,74.68l-3.29,1.14-.93,3.36a.4.4,0,0,1-.7.13l-2.1-2.78-3.48.16a.39.39,0,0,1-.34-.62l2-2.86L141.82,70a.4.4,0,0,1,.49-.52l3.33,1,2.73-2.17a.4.4,0,0,1,.64.3l.07,3.48L152,74A.4.4,0,0,1,151.9,74.68Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.56,
    cy: 175.34,
    r: 1.56,
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,156.26l-1.33,3.22,1.9,2.92a.39.39,0,0,1-.36.61l-3.47-.26-2.19,2.71a.4.4,0,0,1-.7-.16l-.82-3.39-3.25-1.24a.4.4,0,0,1-.07-.71l3-1.82.18-3.48a.39.39,0,0,1,.65-.28l2.65,2.25,3.37-.9A.39.39,0,0,1,140,156.26Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7,277.23l-2.9,1.94,0,3.48a.4.4,0,0,1-.64.31l-2.74-2.15-3.33,1a.4.4,0,0,1-.49-.52l1.21-3.27-2-2.84a.39.39,0,0,1,.34-.62l3.48.13,2.08-2.79a.39.39,0,0,1,.7.13l1,3.35,3.3,1.12A.39.39,0,0,1,108.7,277.23Z",
    style: {
      fill: "#f4f4f4"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Meteorites--inject-1--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--meteorites--inject-1--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.12,219.87a3.14,3.14,0,0,1,6.28,0c0,1.74-1.4,64.3-3.14,64.3S363.12,221.61,363.12,219.87Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.06,219.87a2.2,2.2,0,1,1,2.2,2.2A2.21,2.21,0,0,1,364.06,219.87Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.85,219.87a1.41,1.41,0,1,1,1.41,1.41A1.41,1.41,0,0,1,364.85,219.87Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,282.8a1.67,1.67,0,1,1,3.34,0c0,.92-.74,34.27-1.67,34.27S154,283.72,154,282.8Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.62,
    cy: 282.8,
    r: 1.17,
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.87,282.8a.75.75,0,1,1,.75.75A.75.75,0,0,1,154.87,282.8Z",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.67,152.53a2.19,2.19,0,0,1,4.37,0c0,1.21-1,44.69-2.19,44.69S178.67,153.74,178.67,152.53Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.33,152.53a1.53,1.53,0,1,1,1.52,1.53A1.53,1.53,0,0,1,179.33,152.53Z",
    style: {
      fill: "#F36B1C"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.85,
    cy: 152.53,
    r: 0.98,
    style: {
      fill: "#f4f4f4"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.e1220bdd85dbe8fbf27dac07556d3f21.svg";
export { ForwardRef as ReactComponent };